import api from "./api"
import { icerikTipiDegisti } from "./content-type-broadcast"

// === Tipler (backend src/content-types ile hizalı) =======================

export type SectionKind = "SECTION" | "GROUP"

export type FieldType =
  | "TEXT"
  | "TEXTAREA"
  | "NUMBER"
  | "DATE"
  | "TIME"
  | "BOOLEAN"
  | "SELECT"
  | "MULTI_SELECT"
  | "RADIO"
  | "CHECKBOX"
  | "EMAIL"
  | "PHONE"
  | "FILE"
  | "SIGNATURE"
  /** İl/ilçe gibi KADEMELİ liste: seçenekler ağaç, değer kademelerin dizisi. */
  | "LINKED_SELECT"
  /**
   * DEĞERLENDİRME TABLOSU: kriter satırları × seçenek sütunları (U/UD/UZ) +
   * açıklama. Tanım `options`ta (bkz. `lib/degerlendirme-tablosu`).
   */
  | "EVALUATION_TABLE"
  /** PERSONEL: şirket personelinden biri; değer `{ id, name, code }`. */
  | "PERSONNEL"
  /**
   * TABLO: sütunlar tanımda (`options`, bkz. `lib/tablo-alani`), satırları
   * dolduran ekler; değer satır nesnelerinin dizisi.
   */
  | "TABLE"

export interface FieldValidation {
  min?: number
  max?: number
  minLength?: number
  maxLength?: number
  regex?: string
}

/** options için normalize biçim. Backend string[] de kabul eder; biz {label,value} gönderiyoruz. */
export interface FieldOption {
  label: string
  value: string
  /**
   * KADEMELİ listede bu seçeneğin alt listesi (il → ilçe). Yalnız
   * `LINKED_SELECT` doldurur; yaprakta hiç bulunmaz.
   */
  children?: FieldOption[]
  /** TABLO alanında sütunun tipi (TEXT | NUMBER | DATE | SELECT). */
  type?: string
  /**
   * Bu seçenek, kontrol eden alanın hangi seçimlerinde görünsün?
   * Boş/verilmemiş = her zaman. (bkz. `FieldDefinition.optionsFromKey`)
   */
  when?: string[]
}

export interface FieldDefinition {
  id: string
  key: string
  label: string
  /**
   * ÇİZİM ANINDA verilen kilit (kayıtlı tanımda yok): faaliyet dosyasında
   * Genel Bilgiler'den gelen alan formda salt-okunur çizilir.
   */
  kilitli?: boolean
  /**
   * Faaliyet dosyasında değer Genel Bilgiler'den gelir mi? Varsayılan
   * (undefined/true) evet; `false` = bu formda ayrıca doldurulur.
   */
  genelBilgilerden?: boolean
  fieldType: FieldType
  required: boolean
  options: FieldOption[] | string[] | null
  validation: FieldValidation | null
  defaultValue: unknown | null
  visibleWhen: unknown | null
  helpText: string | null
  /** Boş girdide gri görünen ipucu metni. */
  placeholder?: string | null
  /** Etiketin girdiye göre yönü: "top" (varsayılan) ya da "left". */
  labelPosition?: string | null
  /**
   * Seçim alanlarında seçeneklerin dizilişi: "dikey" (alt alta) ya da
   * "yatay" (yan yana). Null = türün varsayılanı — bkz. `secenekDizilisi`.
   */
  optionLayout?: string | null
  /**
   * Seçenekleri KONTROL EDEN alanın anahtarı (aynı bölümde).
   *
   * "Askı Tipi" listesinin "Tahrik Tipi" seçimine göre daralması gibi. Hangi
   * seçeneğin hangi seçimde görüneceği `options[].when` içinde.
   */
  optionsFromKey?: string | null
  /**
   * SAYI alanında virgülden sonra kaç basamak gösterileceği (0-6).
   *
   * Ölçü alanlarında "0,50" gibi değerler giriliyor; ayarsızken girdi tam
   * sayı adımıyla çalışıyor ve değer "0.5" olarak görünüyordu. Null =
   * ayarlanmamış, eski davranış.
   */
  decimals?: number | null
  /**
   * Değeri BAŞKA ALANLARDAN hesaplayan formül ("genislik * yukseklik").
   *
   * Doluysa alan elle doldurulmuyor: form doldurulurken hesaplanıp kayda
   * yazılıyor, çıktı da o değeri basıyor. Null = elle doldurulan alan.
   */
  formula?: string | null
  sortOrder: number
}

/** Hem taslak ağaç hem de yayınlanmış snapshot bu şekli paylaşır. */
export interface SectionNode {
  id: string
  key: string
  label: string
  kind: SectionKind
  repeatable: boolean
  sortOrder: number
  fields: FieldDefinition[]
  children: SectionNode[]
}

/** İçerik tipinin bağlı olduğu kapsam (global Scope) özeti. */
export interface ContentTypeScope {
  id: string
  code: string | null
  title: string
}

export interface ContentType {
  id: string
  key: string
  /** Formlar listesinde bölüm içi sıra (sürükle-bırak). */
  groupSortOrder?: number
  /** FORM ya da KAPAK — ekranlar ve seçiciler buna göre süzüyor. */
  kind?: "FORM" | "COVER"
  label: string
  description: string | null
  /** Belge künyesi: formun üstünde/yerleşimde basılan doküman kodu. */
  code: string | null
  /** Belge künyesi: revizyon numarası. */
  revisionNo: string | null
  /** Revizyon gerekçesi (zengin metin) — "bu revizyonda ne değişti, neden". */
  revisionNote?: string | null
  revisionDate?: string | null
  isSystem: boolean
  activeVersionId: string | null
  /** Onay aşaması — Onay sekmesi ve başlık rozeti bunu okuyor. */
  approvalStatus?: "DRAFT" | "IN_REVIEW" | "PUBLISHED"
  /** Yürürlük tarihi: İLK yayında atanır, sonraki yayınlara taşınır. */
  effectiveDate?: string | null
  publishedAt?: string | null
  /** Dokümantasyon ağacındaki yeri (Dokümantasyon Klasörü). */
  documentFolderId?: string | null
  /** Form listesindeki bölüm (gruplama). */
  groupId?: string | null
  scopeId: string | null
  scope?: ContentTypeScope | null
  /**
   * ANTET şablonu — kontrol listelerindekiyle aynı havuz. Seçiliyse tasarımcı,
   * önizleme ve PDF her sayfaya üst/alt bandı basar; antetteki künye alanları
   * bu formun kendi künyesinden doluyor.
   */
  companyTemplateId?: string | null
  companyTemplate?: {
    id: string
    name: string
    layout: CompanyTemplateLayout
    isActive: boolean
  } | null
  /**
   * ANTET GRUBU — antetin toplu yönetimi ("Dikey 4x4" gibi). Grup seçiliyse
   * antet GRUPTAN gelir ve `companyTemplate` yok sayılır; grubun anteti
   * değişince bu form da kendiliğinden değişir.
   */
  templateGroupId?: string | null
  templateGroup?: {
    id: string
    name: string
    template: {
      id: string
      name: string
      layout: CompanyTemplateLayout
      isActive: boolean
    } | null
  } | null
  createdAt: string
  updatedAt: string
  _count?: { sections: number; versions: number }
}

export interface ContentTypeWithTree extends ContentType {
  sections: SectionNode[]
  /** Taslak serbest yerleşim tasarımı (yayınlanmamış olabilir). */
  layoutJson?: CanvasLayout | null
}

export interface ResolvedSchema {
  contentTypeId: string
  key: string
  label: string
  /** Yayınlandığı andaki belge künyesi (eski sürümlerde null). */
  code: string | null
  revisionNo: string | null
  version: number
  versionId: string
  sections: SectionNode[]
  /** Yayınlanmış yerleşim; null ise klasik yığın form kullanılır. */
  layout: CanvasLayout | null
}

export interface ContentTypeVersionSummary {
  id: string
  version: number
  publishedAt: string
  publishedBy: string | null
}

// === Serbest yerleşim (A4 canvas) ========================================
//
// Bölüm/alan ağacı verinin tek kaynağıdır; layout yalnız KONUM tutar.
// Tüm ölçüler **mm** (A4: 210x297; yatayda 297x210) → zoom'dan bağımsız,
// baskıda birebir. Backend `src/content-types/types/schema.types.ts` ile hizalı.

export type PageOrientation = "portrait" | "landscape"

/**
 * v1: A4 sabit, sayfa boyutu belge-genel `orientation`'dan gelir.
 * v2: sayfa boyutu sayfanın kendisinden gelir (`page.size`) ve belge bir PDF
 *     şablonunun üstüne bindirilebilir (`template`). Okuma yollarında her zaman
 *     `migrateLayout()` ile normalize edin; kaydetme daima v2 yazar.
 */
export interface CanvasLayout {
  version: 1 | 2
  /** v2'de yalnız geriye uyum + şablonsuz sayfaların varsayılanı. */
  orientation: PageOrientation
  /** v2: arka plan PDF şablonu. Yoksa klasik (şablonsuz) davranış. */
  template?: CanvasTemplate | null
  pages: CanvasPage[]
}

/**
 * Orijinal form PDF'i. Tasarımına dokunulmaz: ekranda arka plan olarak çizilir,
 * çıktıda değerler bu PDF'in üstüne damgalanır.
 *
 * Şablon dosyaları **değiştirilmez**: yeni şablon = yeni File kaydı. Böylece
 * yayınlanmış sürümlerin dondurduğu yerleşim hep aynı belgeyi gösterir.
 */
export interface CanvasTemplate {
  /** files tablosundaki File.id (R2'de saklanır). */
  fileId: string
  /** Yalnız gösterim/teşhis için; yetki kararı asla buna dayanmaz. */
  filename?: string
  pageCount: number
  /** Bütünlük kontrolü: dosya değiştiyse yerleşim uyarı verebilir. */
  sha256?: string
  /** Şablonda gerçek AcroForm alanları bulundu mu (tespit kaynağı). */
  acroform?: boolean
}

export interface CanvasPage {
  id: string
  items: CanvasItem[]
  /**
   * v2: sayfanın gerçek ölçüsü (mm) — döndürme UYGULANMIŞ görsel boyut.
   * Yoksa `pageSizeMm(layout.orientation)` kullanılır (v1 uyumu).
   */
  size?: { width: number; height: number }
  /** v2: bu sayfanın arkasına alınan şablon sayfası (0-tabanlı). */
  templatePage?: number
  /** Şablon sayfasının PDF /Rotate değeri; damgalama matematiği için gerekir. */
  rotate?: 0 | 90 | 180 | 270
  /**
   * Sayfanın ARKA IZGARASI — Excel'deki hücre zemininin karşılığı.
   *
   * Öğe değil SAYFA özelliği: taşınmaz, silinmez, hep yazdırılabilir alana
   * oturur. Çizgileri yalnız TASARIM kılavuzudur; önizlemede de çıktıda da
   * görünmez. Kâğıda basılan tek şey, kullanıcının açıkça `border: true`
   * verdiği hücrelerin çerçevesi ve hücre içerikleridir.
   *
   * Şekli `CanvasGridItem` ile birebir aynı — böylece `canvas-grid` saf
   * modülü, çizici, denetçi ve damgalayıcı hiç değişmeden çalışıyor.
   */
  grid?: CanvasGridItem | null
  /** Sayfanın arka planı (renk + görsel). Bkz. `CanvasPageBackground`. */
  background?: CanvasPageBackground | null
  /**
   * GRUPLAR — kullanıcının seçip grupladığı satır bantları ve nerede
   * basılacakları (ör. "Değerlendirme Sonucu" her sayfanın en altında).
   * Bkz. `lib/tablo-devam` › `gruplariYerlestir`.
   */
  gruplar?: SayfaGrubu[] | null
  /**
   * ESKİ ayar (yerini `gruplar` aldı): akan tablonun altındaki her şey tek
   * blok sayılırdı. Okunmaya devam ediyor; yeni kayıtta yazılmıyor.
   */
  altBlok?: AltBlokYerlesimi | null
}

/**
 * Sayfadaki bir GRUP: ızgaranın `r0`..`r1` (hariç) satırları tek parça
 * olarak taşınır ve `yer`e göre basılır:
 *  - `son-sayfa`: yalnız son sayfanın en altında,
 *  - `her-sayfa`: sayfa (akan tablo yüzünden) bölünse de her sayfanın en altında.
 */
export interface SayfaGrubu {
  id: string
  r0: number
  r1: number
  yer: "son-sayfa" | "her-sayfa"
  /** Panelde görünen ad (ör. "Değerlendirme Sonucu"). */
  ad?: string
}

/** Eski `altBlok` ayarı — bkz. `CanvasPage.altBlok`. */
export type AltBlokYerlesimi = "tablo-arkasi" | "son-sayfa" | "her-sayfa"

/**
 * Sayfanın ARKA PLANI — dolgu rengi ve/veya görsel.
 *
 * Yerleşimin parçası, bir öğe değil: taşınmaz, silinmez, hep sayfanın tamamını
 * kaplar. Şablon PDF'inden ayrı — o gerçek bir belgenin üstünde çalışmak için,
 * bu ise tasarımın kendi zemini (antetli kâğıt görüntüsü, filigran).
 */
export interface CanvasPageBackground {
  /** CSS rengi; boş/verilmemiş = zemin yok. */
  color?: string | null
  /** Yüklenen görselin `File.id`'si (R2). */
  imageFileId?: string | null
  /** Görselin saydamlığı 0..1; verilmemişse 1 (tam opak). */
  opacity?: number
  /** Görselin kutuya oturma biçimi. */
  fit?: "contain" | "cover"
}

/** Tüm öğelerin ortak kutu geometrisi (mm). */
export interface CanvasBox {
  id: string
  x: number
  y: number
  w: number
  h: number
}

export type CanvasItem =
  | CanvasFieldItem
  | CanvasMetaItem
  | CanvasTextItem
  | CanvasBoxItem
  | CanvasLineItem
  | CanvasImageItem
  | CanvasTableItem
  | CanvasGridItem

export type CanvasItemType = CanvasItem["type"]

/**
 * IZGARA — Excel benzeri hücre yerleşimi.
 *
 * Form belgelerinin doğal yapısı serbest konumlanmış kutular değil, tablodur.
 * Bu öğe sayfada bir dikdörtgen kaplar ve içini satır/sütun ölçülerine göre
 * böler; hücreler birleştirilebilir (C3:H3 gibi).
 *
 * ÖLÇÜLER SABİT mm — içeriğe göre büyüme bilinçli olarak yok. Yükseklik metne
 * göre hesaplansaydı DOM ile pdf-lib'in metin ölçümü farklı olduğu için ekran
 * ile kâğıt ayrışırdı.
 *
 * Geometri BURADA DEĞİL, `canvas-grid` saf modülünde (senkron çift): hücre
 * kutusu `cellRect()` ile hesaplanır ve mutlak konumlu öğelerle AYNI `{x,y,w,h}`
 * şeklini döndürür — mevcut çiziciler değişmeden çalışsın diye.
 *
 * `CanvasTableItem` ile karıştırılmamalı: o TEKRARLI veri için (doldurma anında
 * N satır üretir), bu ise SABİT yapı için.
 */
export interface CanvasGridItem extends CanvasBox {
  type: "grid"
  /** Sütun genişlikleri (mm), soldan sağa. */
  cols: number[]
  /** Satır yükseklikleri (mm), yukarıdan aşağı. */
  rows: number[]
  /** YALNIZ dolu hücreler — seyrek saklanır. */
  cells: CanvasGridCell[]
  /** Çerçeveli hücrelerin (`border: true`) çizgi rengi ve kalınlığı. */
  borderColor?: string
  borderWidth?: number
}

/**
 * Bir hücre. Kapsanan (birleşmeye kurban giden) hücreler SAKLANMAZ; kapsama
 * `rowSpan`/`colSpan`'dan türetilir.
 */
export interface CanvasGridCell {
  r: number
  c: number
  /** Yoksa 1. */
  rowSpan?: number
  /** Yoksa 1. */
  colSpan?: number
  /** Hücrenin içeriği. Boş hücre kayıt olarak hiç tutulmaz. */
  content?: CanvasGridCellContent
  align?: "left" | "center" | "right"
  valign?: "top" | "middle" | "bottom"
  fill?: string
  /**
   * İÇERİK (yazı) rengi. Dolgu gibi HÜCREYE ait: içerik türü ne olursa olsun
   * (metin, alan, künye) aynı kural işlesin ve aralık seçiminde tek seferde
   * uygulanabilsin.
   *
   * Metin içeriğinin kendi `color`u varsa o kazanır — eski kayıtlarda
   * kullanılmış olabilir, sessizce değiştirmek yerine üstünlük veriliyor.
   */
  color?: string
  /**
   * YAZI BİÇİMİ — kalın / italik. Renk gibi HÜCREYE ait: içerik türü ne olursa
   * olsun (metin, alan, künye) aynı kural işlesin ve aralık seçiminde tek
   * seferde uygulanabilsin.
   *
   * Metin içeriğinin kendi `bold`/`italic`i varsa o kazanır — eski kayıtlarda
   * kullanılmış olabilir. Denetçi biçimi değiştirirken o eski alanları
   * temizliyor, böylece ileriye dönük tek kaynak hücre oluyor.
   */
  bold?: boolean
  italic?: boolean
  /** ALTI ÇİZİLİ — kalın/italik ile aynı kural: biçim hücreye ait. */
  underline?: boolean
  /**
   * ÇERÇEVE — hangi kenarların kâğıda basılacağı.
   *
   * Varsayılan KAPALI: arka ızgaranın çizgileri bir tasarım kılavuzu, belgenin
   * parçası değil. Formun görünen çerçevelerini kullanıcı çiziyor.
   *
   * İki şekil de geçerli:
   *  - `true` → dört kenar (ESKİ kayıtlar böyle; dönüştürülmüyor).
   *  - `{ top, right, bottom, left }` → yalnız işaretli kenarlar.
   *
   * Kenar bazlı olması şart: Excel'deki gibi bir hücre GRUBUNUN yalnız DIŞ
   * çerçevesini çizmek, tek boolean ile mümkün değil — o hâlde her hücre kendi
   * kutusunu basıyor ve grubun içi de çizgiyle doluyor.
   */
  border?: boolean | CellBorderSides
  /**
   * Çerçeve kalınlığı (mm) — `border` ile aynı şekil: tek sayı dört kenara,
   * nesne kenar kenar. Kenar bazlı olması şart, yoksa köşe hücresinde kalın
   * dış çerçeve ile ince iç ayraç bir arada duramıyor.
   */
  borderWidth?: number | CellBorderWidths
}

/**
 * Çerçeve çizgi kalınlıkları (mm). KENAR BAZLI saklanır: bir tablonun dış
 * çerçevesi kalın, iç ayraçları ince olabilsin. Hücre başına tek sayı
 * yetmiyordu — köşe hücresinin hem kalın dış hem ince iç kenarı var.
 */
export const BORDER_WIDTHS_MM = { ince: 0.2, normal: 0.5, kalin: 1 } as const
export const DEFAULT_BORDER_WIDTH_MM = BORDER_WIDTHS_MM.ince

/** Kenar başına çizgi kalınlığı (mm). Verilmeyen kenar varsayılanı kullanır. */
export interface CellBorderWidths {
  top?: number
  right?: number
  bottom?: number
  left?: number
}

/**
 * Bir hücrenin kenar kalınlıkları (mm): önce hücrenin kendisi, sonra ızgara
 * geneli, sonra varsayılan. Ekran ve PDF aynı yerden okusun diye burada.
 *
 * Tek sayı da kabul ediliyor — dört kenara birden uygulanır (kısa şekil).
 */
export function cellBorderWidths(
  cell: { borderWidth?: number | CellBorderWidths } | undefined,
  item: { borderWidth?: number } | undefined,
): Required<CellBorderWidths> {
  const varsayilan = item?.borderWidth ?? DEFAULT_BORDER_WIDTH_MM
  const w = cell?.borderWidth
  if (w === undefined) {
    return { top: varsayilan, right: varsayilan, bottom: varsayilan, left: varsayilan }
  }
  if (typeof w === "number") return { top: w, right: w, bottom: w, left: w }
  return {
    top: w.top ?? varsayilan,
    right: w.right ?? varsayilan,
    bottom: w.bottom ?? varsayilan,
    left: w.left ?? varsayilan,
  }
}

/** Hücrenin kenar bazlı çerçevesi. Verilmeyen kenar çizilmez. */
export interface CellBorderSides {
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
}

/** Çerçeve kaydını dört kenara açar — `true` eski kayıtların kısayolu. */
export function borderSides(
  border: boolean | CellBorderSides | undefined,
): Required<CellBorderSides> {
  if (border === true) return { top: true, right: true, bottom: true, left: true }
  if (!border) return { top: false, right: false, bottom: false, left: false }
  return {
    top: !!border.top,
    right: !!border.right,
    bottom: !!border.bottom,
    left: !!border.left,
  }
}

/**
 * Hücrenin yazı biçimi: içeriğin ESKİ kendi alanı varsa o kazanır, yoksa
 * hücreninki. Ekran ve PDF aynı yerden okusun diye burada — renkte olduğu gibi.
 */
export function cellTextStyle(
  cell: { bold?: boolean; italic?: boolean; underline?: boolean },
  content: CanvasGridCellContent | undefined,
): { bold: boolean; italic: boolean; underline: boolean } {
  const metin = content?.kind === "text" ? content : undefined
  return {
    bold: metin?.bold ?? cell.bold ?? false,
    italic: metin?.italic ?? cell.italic ?? false,
    // Altı çizili yalnız HÜCREDE tutuluyor: eski kayıtlarda içerik içinde
    // böyle bir alan hiç olmadı, ileriye dönük tek kaynak hücre.
    underline: cell.underline ?? false,
  }
}

/** Hiç kenarı yoksa kayıtta hiç tutulmasın (seyrek saklama). */
export function hasAnyBorder(border: boolean | CellBorderSides | undefined): boolean {
  const s = borderSides(border)
  return s.top || s.right || s.bottom || s.left
}

/**
 * Hücre içeriği — geometri TAŞIMAZ, kutusu ızgaradan gelir.
 * Türler mevcut öğe türlerinin geometrisiz karşılıkları; böylece çiziciler
 * yeni bir içerik kavramı öğrenmek zorunda kalmıyor.
 */
export type CanvasGridCellContent =
  | {
      kind: "text"
      text: string
      bold?: boolean
      italic?: boolean
      fontSize?: number
      color?: string
      /**
       * Metnin PARÇA PARÇA biçimi (renk, kalın, italik, altı çizili) — bir
       * cümlenin içindeki kelimeyi vurgulamak için. Yoksa metnin/hücrenin tek
       * biçimi geçerli.
       *
       * `text` her zaman parçaların birleşimidir ve TEK KAYNAK olarak kalır:
       * arama, dışa aktarma ve parçaları bilmeyen çiziciler onu okur.
       * Uyuşmazlarsa parçalar yok sayılır (bkz. `text-runs.ts`).
       */
      runs?: {
        text: string
        color?: string
        bold?: boolean
        italic?: boolean
        underline?: boolean
      }[]
    }
  | { kind: "field"; path: string; fieldKey: string; showLabel?: boolean; fontSize?: number }
  | { kind: "meta"; metaKey: CompanyTemplateMetaKey; label?: string; fontSize?: number }
  /**
   * Hücre görseli.
   *
   * `fileId` YÜKLENEN dosya (sürükle-bırak), `url` ise dış bağlantı. İkisi de
   * duruyor: eski kayıtlar `url` taşıyor ve bozulmamalı. Çiziciler önce
   * `fileId`ye bakar.
   */
  | { kind: "image"; url?: string; fileId?: string; fit?: "contain" | "cover" }
  /**
   * TESPİT ALANI — bu form bir kontrol listesinin TESPİT FORMU olarak
   * seçildiğinde tespitler bu hücrenin kutusuna akar; sığmayanlar aynı sayfanın
   * kopyalarına taşar. Hücrenin kendisi kâğıda hiçbir şey basmaz.
   */
  | { kind: "findings"; fontSize?: number }


/**
 * Veri alanına bağlı gerçek input.
 * `path`: DynamicForm'un bağlandığı veri yolu ("kapasite", "asansor.kapasite").
 * Normal SECTION yola segment eklemez; yalnız GROUP namespace açar.
 * Tekrarlı GROUP alanları tek tek konumlandırılamaz → CanvasTableItem.
 */
export interface CanvasFieldItem extends CanvasBox {
  type: "field"
  path: string
  labelMode?: "top" | "left" | "none"
  /** labelMode 'left' ise etiket sütunu genişliği (mm). */
  labelWidth?: number
  fontSize?: number
  /** Değer hizalaması (varsayılan "left"; NUMBER için "right" önerilir). */
  align?: "left" | "center" | "right"
  /** Şablonun kendi AcroForm alanından türetildiyse kaynak künyesi. */
  srcField?: { name: string; kind: "Tx" | "Btn" | "Ch" }
}

export interface CanvasTextItem extends CanvasBox {
  type: "text"
  text: string
  fontSize?: number
  bold?: boolean
  italic?: boolean
  align?: "left" | "center" | "right"
  color?: string
}

export interface CanvasBoxItem extends CanvasBox {
  type: "box"
  borderWidth?: number
  borderColor?: string
  fill?: string | null
  radius?: number
}

export interface CanvasLineItem extends CanvasBox {
  type: "line"
  dir: "h" | "v"
  thickness?: number
  color?: string
}

export interface CanvasImageItem extends CanvasBox {
  type: "image"
  url: string
  fit?: "contain" | "cover"
}

/** Tekrarlı GROUP'u tablo olarak basar: satırlar = dizi elemanları. */
export interface CanvasTableItem extends CanvasBox {
  type: "table"
  /** Tekrarlı GROUP'un veri yolu (ör. "standartSapmalar"). */
  groupPath: string
  columns: CanvasTableColumn[]
  rowHeight?: number
  headerHeight?: number
  borderColor?: string
  fontSize?: number
}

export interface CanvasTableColumn {
  /** Grup içindeki alanın anahtarı (grup yoluna göre göreli). */
  key: string
  label: string
  /** Sütun genişliği (mm). */
  width: number
}

// === Payload'lar =========================================================

export interface CreateContentTypePayload {
  /** FORM (varsayılan) ya da KAPAK. Oluşturulduktan sonra değişmez. */
  kind?: "FORM" | "COVER"
  key: string
  label: string
  description?: string
  code?: string | null
  revisionNo?: string | null
  isSystem?: boolean
  scopeId?: string | null
}

export interface CreateSectionPayload {
  key: string
  label: string
  parentId?: string
  kind?: SectionKind
  repeatable?: boolean
  sortOrder?: number
}

export interface UpdateSectionPayload {
  label?: string
  kind?: SectionKind
  repeatable?: boolean
  sortOrder?: number
}

export interface CreateFieldPayload {
  key: string
  label: string
  fieldType?: FieldType
  required?: boolean
  options?: FieldOption[]
  validation?: FieldValidation
  defaultValue?: unknown
  helpText?: string
  placeholder?: string
  labelPosition?: string
  /** Seçenek dizilişi: "dikey" / "yatay"; null = türün varsayılanı. */
  optionLayout?: string | null
  /** Faaliyet dosyasında değer Genel Bilgiler'den mi gelir (varsayılan true). */
  genelBilgilerden?: boolean
  optionsFromKey?: string
  /** SAYI alanında ondalık basamak sayısı (0-6). */
  decimals?: number | null
  /** Değeri başka alanlardan hesaplayan formül. */
  formula?: string | null
  sortOrder?: number
  /**
   * Alan, ALAN KİTAPLIĞINDAN seçilerek eklendiyse true.
   *
   * Sunucu bu alanı kitaplığa geri yazmıyor: kaynağı zaten kitaplık, yazsaydı
   * aynı tanım "form alanları" grubunda ikinci kez belirirdi.
   */
  fromLibrary?: boolean
}

export type UpdateFieldPayload = Partial<CreateFieldPayload>

// Belgeden içe aktarma (tam ağaç, tek transaction'da yaratılır) ---------

export interface ImportFieldPayload {
  key: string
  label: string
  fieldType?: FieldType
  required?: boolean
  options?: FieldOption[]
}

export interface ImportSectionPayload {
  key: string
  label: string
  kind?: SectionKind
  repeatable?: boolean
  fields: ImportFieldPayload[]
  children: ImportSectionPayload[]
}

export interface ImportContentTypePayload {
  key: string
  label: string
  description?: string
  sections: ImportSectionPayload[]
  /** Otomatik üretilen A4 yerleşim taslağı (opsiyonel). */
  layout?: CanvasLayout | null
}

// === İçerik tipi (admin) ================================================

/**
 * Liste TÜRE göre süzülüyor: kapaklar formların arasında görünmemeli — kapak
 * veri toplayan bir belge değil, bir belgenin önüne basılan sayfa.
 */
export async function fetchContentTypes(kind: "FORM" | "COVER" = "FORM") {
  const { data } = await api.get<ContentType[]>("/admin/content-types", {
    params: { kind },
  })
  return data
}

export async function fetchContentType(key: string) {
  const { data } = await api.get<ContentTypeWithTree>(`/admin/content-types/${key}`)
  return data
}

export async function createContentType(payload: CreateContentTypePayload) {
  const { data } = await api.post<ContentType>("/admin/content-types", payload)
  return data
}

/** Belgeden ayrıştırılmış tam ağacı tek transaction'da taslak olarak yaratır. */
export async function importContentType(payload: ImportContentTypePayload) {
  const { data } = await api.post<ContentTypeWithTree>(
    "/admin/content-types/import",
    payload,
  )
  return data
}

/**
 * Künye alanlarını günceller.
 *
 * Yazma başarılı olunca ÖTEKİ SEKMELERE haber veriliyor: form detayı ayrı bir
 * sekmede açılıyor ve liste sekmesi buradaki ad/kod değişikliğini kendiliğinden
 * göremiyordu (bkz. `content-type-broadcast.ts`).
 */
export async function updateContentType(
  id: string,
  payload: {
    label?: string
    description?: string | null
    code?: string | null
    revisionNo?: string | null
    /** Revizyon gerekçesi (zengin metin); kontrol listesindekiyle aynı alan. */
    revisionNote?: string | null
    scopeId?: string | null
    /** Antet şablonu; null = şablonsuz. */
    companyTemplateId?: string | null
    /** Antet grubu; null = gruptan çıkar. Grup seçiliyse antet gruptan gelir. */
    templateGroupId?: string | null
    /** ISO tarih; null → yürürlük tarihini temizle. */
    effectiveDate?: string | null
    /** null → klasörden çıkar. */
    documentFolderId?: string | null
  },
) {
  const { data } = await api.patch<ContentType>(`/admin/content-types/${id}`, payload)
  icerikTipiDegisti()
  return data
}

export async function deleteContentType(id: string) {
  await api.delete(`/admin/content-types/${id}`)
  icerikTipiDegisti()
}

/** Serbest yerleşim tasarımını kaydeder. `null` → yerleşimi kaldır. */
export async function saveContentTypeLayout(
  id: string,
  layout: CanvasLayout | null,
) {
  const { data } = await api.put<ContentType>(
    `/admin/content-types/${id}/layout`,
    { layout },
  )
  return data
}

/**
 * Yerleşim önizlemesini PDF olarak indirir ("PDF kaydet").
 *
 * Yerleşim ve deneme verisi GÖVDEDE gider: tasarım ekranında henüz
 * kaydedilmemiş taslak da basılabilmeli. Dosya adını sunucu belirler (künye +
 * başlık); istemcide yeniden türetmek ikisinin ayrışmasına yol açardı.
 */
export async function downloadLayoutPdf(
  id: string,
  body: {
    layout?: CanvasLayout | null
    data?: Record<string, unknown>
    versionId?: string
  },
): Promise<void> {
  const res = await api.post<Blob>(
    `/admin/content-types/${id}/preview-pdf`,
    body,
    { responseType: "blob" },
  )

  const disposition = String(res.headers["content-disposition"] ?? "")
  const match = /filename\*=UTF-8''([^;]+)/i.exec(disposition)
  const fileName = match ? decodeURIComponent(match[1]) : "onizleme.pdf"

  const url = URL.createObjectURL(res.data)
  try {
    const a = document.createElement("a")
    a.href = url
    a.download = fileName
    a.click()
  } finally {
    // Blob URL'i serbest bırak; yoksa sekme kapanana dek bellekte kalır.
    URL.revokeObjectURL(url)
  }
}

export async function publishContentType(id: string) {
  const { data } = await api.post<ContentTypeVersionSummary>(`/admin/content-types/${id}/publish`)
  // Yayınlama listedeki "Taslak/Yayında" rozetini değiştiriyor.
  icerikTipiDegisti()
  return data
}

export async function fetchVersions(id: string) {
  const { data } = await api.get<ContentTypeVersionSummary[]>(`/admin/content-types/${id}/versions`)
  return data
}

export interface ContentTypeVersionDetail extends ContentTypeVersionSummary {
  schemaJson: {
    key: string
    label: string
    sections: SectionNode[]
    layout: CanvasLayout | null
  }
}

/** Tek versiyonu snapshot'ıyla getirir (önizleme). */
export async function fetchVersion(id: string, versionId: string) {
  const { data } = await api.get<ContentTypeVersionDetail>(
    `/admin/content-types/${id}/versions/${versionId}`,
  )
  return data
}

/** Bir versiyonu taslağa geri yükler (yayınlanınca yeni versiyon olur). */
export async function restoreVersion(id: string, versionId: string) {
  const { data } = await api.post<ContentTypeWithTree>(
    `/admin/content-types/${id}/versions/${versionId}/restore`,
  )
  return data
}

// === Bölüm (Section) =====================================================

export async function createSection(contentTypeId: string, payload: CreateSectionPayload) {
  const { data } = await api.post<SectionNode>(
    `/admin/content-types/${contentTypeId}/sections`,
    payload,
  )
  return data
}

export async function updateSection(
  contentTypeId: string,
  sectionId: string,
  payload: UpdateSectionPayload,
) {
  const { data } = await api.patch<SectionNode>(
    `/admin/content-types/${contentTypeId}/sections/${sectionId}`,
    payload,
  )
  return data
}

export async function deleteSection(contentTypeId: string, sectionId: string) {
  await api.delete(`/admin/content-types/${contentTypeId}/sections/${sectionId}`)
}

export async function reorderSections(contentTypeId: string, ids: string[]) {
  await api.post(`/admin/content-types/${contentTypeId}/sections/reorder`, { ids })
}

// === Alan (FieldDefinition) =============================================

export async function createField(sectionId: string, payload: CreateFieldPayload) {
  const { data } = await api.post<FieldDefinition>(
    `/admin/content-sections/${sectionId}/fields`,
    payload,
  )
  return data
}

export async function updateField(
  sectionId: string,
  fieldId: string,
  payload: UpdateFieldPayload,
) {
  const { data } = await api.patch<FieldDefinition>(
    `/admin/content-sections/${sectionId}/fields/${fieldId}`,
    payload,
  )
  return data
}

export async function deleteField(sectionId: string, fieldId: string) {
  await api.delete(`/admin/content-sections/${sectionId}/fields/${fieldId}`)
}

export async function reorderFields(sectionId: string, ids: string[]) {
  await api.post(`/admin/content-sections/${sectionId}/fields/reorder`, { ids })
}

// === Şema çözümleme (form render) =======================================

export async function fetchSchema(key: string) {
  const { data } = await api.get<ResolvedSchema>(`/content-types/${key}/schema`)
  return data
}

// === Yardımcılar =========================================================

export const FIELD_TYPE_LABELS: Record<FieldType, string> = {
  TEXT: "Metin",
  TEXTAREA: "Uzun Metin",
  NUMBER: "Sayı",
  DATE: "Tarih",
  TIME: "Saat",
  BOOLEAN: "Evet/Hayır",
  SELECT: "Açılır Liste",
  MULTI_SELECT: "Çoklu Seçim",
  RADIO: "Radyo Buton",
  CHECKBOX: "Onay Kutuları",
  EMAIL: "E-posta",
  PHONE: "Telefon",
  FILE: "Dosya",
  SIGNATURE: "İmza",
  LINKED_SELECT: "İlişkili liste",
  EVALUATION_TABLE: "Tablo",
  PERSONNEL: "Personel",
  TABLE: "Tablo (eski)",
}

/** Seçenek gerektiren alan tipleri (options zorunlu). */
export const OPTION_FIELD_TYPES: FieldType[] = [
  "SELECT",
  "MULTI_SELECT",
  "RADIO",
  "CHECKBOX",
  "EVALUATION_TABLE",
  "TABLE",
]

/** options'ı her iki biçimden ({label,value} | string) normalize eder. */
export function normalizeOptions(
  options: FieldOption[] | string[] | null | undefined,
): FieldOption[] {
  if (!Array.isArray(options)) return []
  return options.map((opt) =>
    typeof opt === "string" ? { label: opt, value: opt } : opt,
  )
}

/** Seçim alanlarında seçeneklerin dizilişi: alt alta ya da yan yana. */
export type SecenekDizilisi = "dikey" | "yatay"

/** Seçenek dizilişi ayarlanabilen alan tipleri. */
export const DIZILISLI_FIELD_TYPES: FieldType[] = ["SELECT", "RADIO", "MULTI_SELECT", "CHECKBOX"]

/**
 * Alanın ETKİN seçenek dizilişi. Ayarlanmamışsa (null) türün varsayılanı:
 * çoklu seçimler (MULTI_SELECT/CHECKBOX) alt alta, tekli seçimler yan yana.
 * Sunucudaki PDF damgalayıcı (`canvas-metrics.secenekDizilisi`) aynı kuralı
 * kullanıyor — ekranla kâğıt ayrışmasın.
 */
export function secenekDizilisi(field: {
  fieldType: string
  optionLayout?: string | null
}): SecenekDizilisi {
  if (field.optionLayout === "dikey" || field.optionLayout === "yatay") return field.optionLayout
  return field.fieldType === "MULTI_SELECT" || field.fieldType === "CHECKBOX" ? "dikey" : "yatay"
}

// === Şirket belge şablonu (üst/alt bilgi) ================================
//
// Kontrol listesi gibi BİZİM çizdiğimiz belgelerin çevresine giydirilen antet.
// Öğeler A4 SAYFA koordinatlarında (mm) durur; hangi banda ait oldukları
// `y` değerinden türetilir — tasarımcı sayfanın tamamını gösterdiği için tek
// koordinat sistemi taşımayı ve doğrulamayı basitleştiriyor.

/** Şablonun doldurabileceği künye alanları. */
export type CompanyTemplateMetaKey = SabitMetaKey | `musteri.${string}`

/**
 * MÜŞTERİ künyesi — faaliyet dosyasının müşterisinden dolar; dosya dışında
 * boş kalır ve basılmaz. Müşteri formunun EK alanları `musteri.<anahtar>`.
 */
export type MusteriMetaKey =
  | 'musteriUnvani'
  | 'musteriKisaAd'
  | 'musteriVergiDairesi'
  | 'musteriVergiNo'
  | 'musteriAdres'
  | 'musteriIl'
  | 'musteriIlce'
  | 'musteriTelefon'
  | 'musteriEposta'
  | 'musteriWebSitesi'
  | 'musteriTuru'
  | 'musteriYetkili'
  | 'musteriYetkiliGorev'
  | 'musteriYetkiliTelefon'
  | 'musteriYetkiliEposta'

export const MUSTERI_META_KEYS: MusteriMetaKey[] = [
  'musteriUnvani', 'musteriKisaAd', 'musteriVergiDairesi', 'musteriVergiNo', 'musteriAdres',
  'musteriIl', 'musteriIlce', 'musteriTelefon', 'musteriEposta', 'musteriWebSitesi', 'musteriTuru',
  'musteriYetkili', 'musteriYetkiliGorev', 'musteriYetkiliTelefon', 'musteriYetkiliEposta',
]

export type SabitMetaKey =
  | MusteriMetaKey
  | 'documentName'
  | 'documentCode'
  | 'publishDate'
  | 'revisionNo'
  | 'revisionDate'
  | 'effectiveDate'
  | 'pageNo'
  /**
   * FAALİYET DOSYASI alanları — antete bakarken ve form içinde BOŞ durur;
   * yalnız bir faaliyet dosyası bağlamında (dosyanın içinden yazdırılırken)
   * dolar. Boş künye alanı basılmıyor (bkz. `CanvasGridContent`), o yüzden
   * dosyasız çıktıda yer kaplamıyorlar.
   */
  | 'dosyaNo'
  | 'updatedAt'

export const COMPANY_TEMPLATE_META_KEYS: SabitMetaKey[] = [
  'documentName',
  'documentCode',
  'publishDate',
  'revisionNo',
  'revisionDate',
  'effectiveDate',
  'pageNo',
  'dosyaNo',
  'updatedAt',
  ...MUSTERI_META_KEYS,
]

/**
 * Künye alanına bağlı metin.
 *
 * `field` öğesinden AYRI bir tip: o, dinamik formun veri yoluna bağlanıyor ve
 * DOLDURULABİLİR bir input çiziyor. Bu ise salt-okunur bir DEĞER basıyor ve
 * kaynağı belgenin künyesi. İkisini tek tipte birleştirmek, iki farklı
 * çalışma-zamanını aynı dala sokmak olurdu.
 */
export interface CanvasMetaItem extends CanvasBox {
  type: 'meta'
  metaKey: CompanyTemplateMetaKey
  /** Değerin soluna basılan sabit etiket ("Doküman No:" gibi). */
  label?: string
  fontSize?: number
  bold?: boolean
  align?: 'left' | 'center' | 'right'
  color?: string
}

/** Şablonun tamamı: iki bant yüksekliği + A4 sayfa koordinatlı öğeler. */
export interface CompanyTemplateLayout {
  /** Üst bandın yüksekliği (mm, sayfanın üstünden). */
  headerHeightMm: number
  /** Alt bandın yüksekliği (mm, sayfanın altından). */
  footerHeightMm: number
  orientation: PageOrientation
  items: CanvasItem[]
  /**
   * Bandın KUTU KUTU (ızgara) tasarımı — form tasarımcısındaki sayfa
   * ızgarasının aynısı. Antetler kâğıtta zaten hücreli tablolar; serbest
   * konumlu kutularla hizalamak elle piksel ayarlamak demekti.
   *
   * `items` ile BİRLİKTE yaşıyor: eski şablonlar serbest öğelerle çizilmiş,
   * onları ızgaraya çevirmek geri alınamaz bir dönüşüm olurdu. Izgara varsa
   * bandın zemini o; öğeler üstünde çizilmeye devam eder.
   */
  headerGrid?: CanvasGridItem | null
  footerGrid?: CanvasGridItem | null
  /**
   * SAYFA IZGARASI — antetin YENİ modeli.
   *
   * Antet artık iki bantla değil, formun sayfasıyla AYNI koordinat sisteminde
   * tek bir ızgarayla tasarlanıyor: kullanıcı sayfanın neresine ne koyduysa,
   * form o anteti kullandığında hücreler oraya "kopyala-yapıştır" yapılmış
   * gibi düşüyor. Bant modeli (`headerGrid`/`footerGrid`) eski şablonlar için
   * duruyor; `pageGrid` varsa çiziciler ONU kullanıyor.
   */
  pageGrid?: CanvasGridItem | null

  /**
   * İÇERİK ALANI — antetin ORTASINDA, belgenin gövdesinin basılacağı bölge
   * (mm, A4 sayfa koordinatları).
   *
   * Antet bir çerçeve: üstünde künye, altında imza, ORTASINDA belgenin
   * kendisi. Bu bölge tanımlıysa kontrol listesi ve form içeriği tam buraya
   * yerleşiyor; tanımlı değilse eski davranış sürüyor (bantlar üstte/altta,
   * içerik aralarında akıyor).
   *
   * Neden dikdörtgen ve hücre değil: gövde AKAN bir içerik (madde tablosu,
   * bölümler). Izgaradan bir aralık seçilip "içerik alanı yap" denince o
   * aralığın dış dikdörtgeni buraya yazılıyor.
   */
  contentArea?: { x: number; y: number; w: number; h: number } | null

  /** Sayfa zemini — formdaki arka planla aynı şekil (renk + görsel). */
  background?: { color?: string | null; imageFileId?: string | null; opacity?: number } | null
}


// === Form listesinin BÖLÜMLERİ ===========================================
//
// Dokümantasyon klasöründen ayrı eksen: klasör belgenin arşivdeki yeri, bölüm
// ise `/formlar` tasarım listesinde nasıl gruplandığı. Düz liste — iç
// içe değil.

export interface ContentTypeGroup {
  id: string
  label: string
  sortOrder: number
  /** Üst bölüm — bölümler iç içe olabilir; null = kök. */
  parentId?: string | null
}

export async function fetchContentTypeGroups() {
  const { data } = await api.get<ContentTypeGroup[]>("/admin/content-types/groups")
  return data
}

export async function createContentTypeGroup(label: string, parentId?: string | null) {
  const { data } = await api.post<ContentTypeGroup>("/admin/content-types/groups", { label, parentId: parentId ?? undefined })
  return data
}

/** Bölümü başka bir bölümün altına (null = en üst seviyeye) taşır. */
export async function moveContentTypeGroup(groupId: string, parentId: string | null) {
  const { data } = await api.patch<ContentTypeGroup>(`/admin/content-types/groups/${groupId}/parent`, { parentId })
  return data
}

export async function renameContentTypeGroup(groupId: string, label: string) {
  const { data } = await api.patch<ContentTypeGroup>(`/admin/content-types/groups/${groupId}`, { label })
  return data
}

/** Bölümü siler; içindeki formlar bölümsüz kalır (silinmez). */
export async function deleteContentTypeGroup(groupId: string) {
  await api.delete(`/admin/content-types/groups/${groupId}`)
}

export async function reorderContentTypeGroups(ids: string[]) {
  const { data } = await api.patch<ContentTypeGroup[]>("/admin/content-types/groups/reorder", { ids })
  return data
}

/** Formu bir bölüme taşır; `null` → bölümsüz. */
/** Formları bölüm içinde verilen sıraya dizer (güncel revizyon kimlikleri). */
export async function reorderContentTypes(ids: string[]) {
  await api.patch("/admin/content-types/groups/types/reorder", { ids })
}

export async function assignContentTypeGroup(id: string, groupId: string | null) {
  const { data } = await api.patch<{ id: string; groupId: string | null }>(
    `/admin/content-types/${id}/group`,
    { groupId },
  )
  return data
}

/** Formu TASLAK olarak kopyalar (bölüm/alan ağacı + yerleşim). */
export async function duplicateContentType(id: string) {
  const { data } = await api.post<ContentType>(`/admin/content-types/${id}/duplicate`)
  return data
}
